export const AUTH_STEPS = {
  LOGIN_FORM: 'LOGIN_FORM',
  SIGNUP_FORM: 'SIGNUP_FORM',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  COMPLETE_FACEBOOK_DATA: 'COMPLETE_FACEBOOK_DATA',
  CLOSE_ANOTHER_SESSIONS: 'CLOSE_ANOTHER_SESSIONS',
  SMS_CONFIRMATION: 'SMS_CONFIRMATION',
  REDIRECTING: 'REDIRECTING',
  REDIRECTING_PREV_URL: 'REDIRECTING_PREV_URL',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  WELCOME_SUCCESS: 'WELCOME_SUCCESS',
}
